import { render, staticRenderFns } from "./CompetitionNoSchool.vue?vue&type=template&id=f723ba7e&scoped=true&"
import script from "./CompetitionNoSchool.vue?vue&type=script&lang=js&"
export * from "./CompetitionNoSchool.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionNoSchool.vue?vue&type=style&index=0&id=f723ba7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f723ba7e",
  null
  
)

export default component.exports